import { z } from "zod";
/**
 * The voice surface (ADR 0011): dictation in, narration out.
 *
 * Neither direction touches game state. Dictation produces text that lands in
 * the learner's own draft, where they read and edit it before it is ever sent
 * as a turn — a transcription error must never become a turn on its own
 * (architecture_validation.md 3.3: "let them edit the transcript before
 * submitting"). Narration audio is a rendering of prose the narrator gate has
 * already passed, addressed by turn rather than by text so the endpoint can
 * only ever voice narration the caller's own session produced.
 */
/** GET /voice — which halves the deployment has actually wired. Both false in cassette mode, by construction. */
export const VoiceCapabilitiesSchema = z.strictObject({
    dictation: z.boolean(),
    narration: z.boolean(),
});
/** POST /voice/transcriptions — the words, and nothing else. No confidence, no timing: those are provider artefacts, not something a learner should be scored against. */
export const TranscriptionResponseSchema = z.strictObject({
    text: z.string(),
});
/** POST /sessions/:id/speech — which turn's narration to voice. Turn 0 is the authored opening. */
export const SpeechRequestSchema = z.strictObject({
    turn: z.number().int().min(0),
});
/**
 * The audio container types a browser's MediaRecorder actually produces, plus
 * the two a file would arrive in. Anything else is refused before a byte
 * reaches a provider.
 */
export const DICTATION_MIME_TYPES = ["audio/webm", "audio/mp4", "audio/ogg", "audio/wav", "audio/mpeg"];
/** Longest single dictation, in seconds. A turn is a paragraph of reasoning, not a lecture; the client stops the recorder here. */
export const DICTATION_MAX_SECONDS = 120;
/** Upload ceiling for one dictation, in bytes — two minutes of Opus at MediaRecorder's default bitrate is well under 2MB; this leaves room for a lossless Safari capture. */
export const DICTATION_MAX_BYTES = 12_000_000;
//# sourceMappingURL=voice.js.map